{
  "2024-2025": [
    {
      "start": "2024-10-19",
      "end": "2024-11-03",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de la Toussaint"
    },
    {
      "start": "2024-12-21",
      "end": "2025-01-05",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de Noël"
    },
    {
      "start": "2025-02-08",
      "end": "2025-02-23",
      "zones": [
        "B"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2025-02-15",
      "end": "2025-03-02",
      "zones": [
        "C"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2025-02-22",
      "end": "2025-03-09",
      "zones": [
        "A"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2025-04-05",
      "end": "2025-04-21",
      "zones": [
        "B"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2025-04-12",
      "end": "2025-04-27",
      "zones": [
        "C"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2025-04-19",
      "end": "2025-05-04",
      "zones": [
        "A"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2025-07-05",
      "end": "2025-08-31",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances d'Été"
    }
  ],
  "2025-2026": [
    {
      "start": "2025-10-18",
      "end": "2025-11-02",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de la Toussaint"
    },
    {
      "start": "2025-12-20",
      "end": "2026-01-04",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de Noël"
    },
    {
      "start": "2026-02-07",
      "end": "2026-02-22",
      "zones": [
        "A"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2026-02-14",
      "end": "2026-03-01",
      "zones": [
        "B"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2026-02-21",
      "end": "2026-03-08",
      "zones": [
        "C"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2026-04-04",
      "end": "2026-04-19",
      "zones": [
        "A"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2026-04-11",
      "end": "2026-04-26",
      "zones": [
        "B"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2026-04-18",
      "end": "2026-05-03",
      "zones": [
        "C"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2026-07-04",
      "end": "2026-08-31",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances d'Été"
    }
  ],
  "2026-2027": [
    {
      "start": "2026-10-17",
      "end": "2026-11-01",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de la Toussaint"
    },
    {
      "start": "2026-12-19",
      "end": "2027-01-03",
      "zones": [
        "A",
        "B",
        "C"
      ],
      "description": "Vacances de Noël"
    },
    {
      "start": "2027-02-06",
      "end": "2027-02-21",
      "zones": [
        "C"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2027-02-13",
      "end": "2027-02-28",
      "zones": [
        "A"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2027-02-20",
      "end": "2027-03-07",
      "zones": [
        "B"
      ],
      "description": "Vacances d'Hiver"
    },
    {
      "start": "2027-04-03",
      "end": "2027-04-18",
      "zones": [
        "C"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2027-04-10",
      "end": "2027-04-25",
      "zones": [
        "A"
      ],
      "description": "Vacances de Printemps"
    },
    {
      "start": "2027-04-17",
      "end": "2027-05-02",
      "zones": [
        "B"
      ],
      "description": "Vacances de Printemps"
    }
  ]
}